import { Navigate, Outlet, useLocation } from "react-router";
import { useMainStore } from "../store/store";
import { Box, CircularProgress } from "@mui/material";

const ProtectedRoute = () => {
  const { isAuthenticated, isLoggedOut, loadingPage } = useMainStore();
  const location = useLocation();
  const isPreview = process.env.REACT_APP_UI_PREVIEW === "true";

  if (isPreview) {
    return <Outlet />;
  }

  if (loadingPage) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress size={200} />
      </Box>
    );
  }

  if (isLoggedOut || !isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
};
export default ProtectedRoute;
